import React from 'react';
import './NotFound.scss';
import {useNavigate} from "react-router-dom";
import {MessageCircleQuestion, Sparkles} from "lucide-react";
import Button from "../../components/ui/Button/Button";
import {TOKEN_STORAGE_KEY} from "../../services/firebase_services";

// Shown for any address the app doesn't know
const NotFound = () => {
    const navigate = useNavigate();
    const signedIn = Boolean(localStorage.getItem(TOKEN_STORAGE_KEY));
    const home = signedIn ? '/' : '/auth';
    // Opened straight from a broken link there's no page to go back to
    const goBack = () => (window.history.length > 1 ? navigate(-1) : navigate(home));

    return (
        <div className="NotFound">
            <a href="/" className="NotFound__logo">
                <span className="icon-tile icon-tile--gradient"><Sparkles size={18}/></span>
                Soulify
            </a>

            <div className="card NotFound__card">
                <div className="NotFound__bubbles" aria-hidden="true">
                    <span className="NotFound__bubble">Hey, are you there?</span>
                    <span className="NotFound__bubble NotFound__bubble--reply">
                        <MessageCircleQuestion size={16}/> …
                    </span>
                </div>

                <span className="NotFound__code">404</span>
                <h1>This page doesn't exist</h1>
                <p>The link may be old or mistyped. Let's get you back to your conversations.</p>

                <div className="NotFound__buttons">
                    <Button type={'button'} variant={'secondary'} title={'Go back'} onClick={goBack}/>
                    <Button type={'button'} variant={'primary'} title={signedIn ? 'Open my chats' : 'Sign in'}
                            onClick={() => navigate(home)}/>
                </div>
            </div>
        </div>
    );
};

export default NotFound;
